import { useParams } from 'react-router-dom'
import { useAcsFetch } from '../hooks/use-acs-fetch'
import { AccountDetails } from '../types'

export interface UpdateOptions {
  accountNickname?: string
  raiseYourRate?: boolean
}

export const useAcctDetailsApi = (): {
  fetchAccountDetails: () => Promise<AccountDetails>
  updateAccountDetails: (options: UpdateOptions) => Promise<AccountDetails>
} => {
  const { id } = useParams<{ id: string }>()
  const acsFetch = useAcsFetch({
    withCif: true,
    withGuid: true,
    defaultHeaders: {
      ApplicationVersion: '2.9',
      ApplicationID: 'ALLYUSBOLB',
      ApplicationName: 'AOB',
    },
  })

  // istanbul ignore next // we have tests for this already but we have to update them once we remove the FF
  const fetchAccountDetails = async (): Promise<AccountDetails> => {
    const result = await acsFetch<Record<string, AccountDetails>>(
      `/v1/bank-accounts/${id}?include=accountAddress`,
    )

    if (result.data) {
      return result.data[Object.keys(result.data)[0]] as AccountDetails
    }
    throw new Error('No account details payload in successful response')
  }

  // istanbul ignore next // we have tests for this already but we have to update them once we remove the FF
  const updateAccountDetails = async (
    options: UpdateOptions,
  ): Promise<AccountDetails> => {
    const result = await acsFetch<Record<string, AccountDetails>>(
      `/v1/bank-accounts/${id}/update`,
      {
        method: 'PATCH',
        body: new URLSearchParams(Object.entries(options)).toString(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
    if (result.data) {
      return result.data[Object.keys(result.data)[0]] as AccountDetails
    }

    throw new Error('No account details payload in successful response')
  }
  return { fetchAccountDetails, updateAccountDetails }
}
